import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_user",
  ref: "addUserModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_user_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_user_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_user_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_user_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "form-group mb-7" }
const _hoisted_11 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_12 = { class: "row mb-7" }
const _hoisted_13 = { class: "col-md-6 form-group" }
const _hoisted_14 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_15 = { class: "col-md-6 form-group" }
const _hoisted_16 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_17 = { class: "row mb-7" }
const _hoisted_18 = { class: "col-md-6 form-group" }
const _hoisted_19 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_20 = { class: "col-md-6 form-group" }
const _hoisted_21 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_22 = { class: "row mb-7" }
const _hoisted_23 = { class: "col-md-6 form-group" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_25 = { class: "col-md-6 form-group" }
const _hoisted_26 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_27 = { class: "row mb-7" }
const _hoisted_28 = { class: "col-md-9 form-group" }
const _hoisted_29 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_30 = { class: "col-md-3 form-group" }
const _hoisted_31 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_32 = { class: "row mb-7" }
const _hoisted_33 = { class: "col-md-6 form-group" }
const _hoisted_34 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_35 = { class: "col-md-6 form-group" }
const _hoisted_36 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_37 = { class: "row mb-7" }
const _hoisted_38 = { class: "col-md-6 form-group" }
const _hoisted_39 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_40 = { class: "col-md-6 form-group" }
const _hoisted_41 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_42 = { class: "modal-footer flex-center" }
const _hoisted_43 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_44 = { class: "indicator-label" }
const _hoisted_45 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_46 = { class: "indicator-progress" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("common.add") + _ctx.t("user.user")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.t("user.userName")), 1),
                  _createVNode(_component_el_form_item, { prop: "username" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.username,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.username) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("user.email")), 1),
                    _createVNode(_component_el_form_item, { prop: "email" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.email,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.email) = $event)),
                          type: "email",
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("user.password")), 1),
                    _createVNode(_component_el_form_item, { prop: "password" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.password,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event)),
                          type: "text",
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("user.firstName")), 1),
                    _createVNode(_component_el_form_item, { prop: "firstname" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.firstname,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.firstname) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("user.lastName")), 1),
                    _createVNode(_component_el_form_item, { prop: "lastname" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.lastname,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.lastname) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("user.mobile")), 1),
                    _createVNode(_component_el_form_item, { prop: "mobile" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.mobile,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("user.telephone")), 1),
                    _createVNode(_component_el_form_item, { prop: "telephone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.telephone,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.telephone) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.t("user.address")), 1),
                    _createVNode(_component_el_form_item, { prop: "address" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.address,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.address) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t("user.zipCode")), 1),
                    _createVNode(_component_el_form_item, { prop: "zip_code" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.zip_code,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.zip_code) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("user.city")), 1),
                    _createVNode(_component_el_form_item, { prop: "city" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.city,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.city) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("user.country")), 1),
                    _createVNode(_component_el_form_item, { prop: "country_iso_2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.country_iso_2,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.country_iso_2) = $event)),
                          clearable: "",
                          filterable: "",
                          placeholder: _ctx.t('user.selectACountry'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.t("user.language")), 1),
                    _createVNode(_component_el_form_item, { prop: "language" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.language,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.language) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('user.selectLanguage'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _ctx.t('user.english'),
                              value: "en_US"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.t('user.simplifiedChinese'),
                              value: "zh_CN"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.t('user.german'),
                              value: "de_DE"
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.t("user.warehouse")), 1),
                    _createVNode(_component_el_form_item, { prop: "wms_default_warehouse" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.wms_default_warehouse,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.wms_default_warehouse) = $event)),
                          clearable: "",
                          filterable: "",
                          placeholder: _ctx.t('user.selectAWarehouse'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wareHouseOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, _toDisplayString(_ctx.t("common.discard")), 1),
              _createElementVNode("button", _hoisted_43, [
                _createElementVNode("span", _hoisted_44, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.submit")) + " ", 1),
                  _createElementVNode("span", _hoisted_45, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _createElementVNode("span", _hoisted_46, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_47
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}